export default __webpack_public_path__ + "static/media/Jovian Spirit Cape.ca0b6557.jpg";